module.exports = __webpack_public_path__ + "img/representante.10bb9ea7.png";